// extracted by mini-css-extract-plugin
export default {"container":"container-eBmYOO9I","body":"body-Xs5Rc9JB"};